import { useAsync } from '@nxsys/hooks/useAsync';
import { addBankNameApi, getBankListApi } from '@nxsys/services/api/bank';
import {
  AddBankNameParams,
  AddBankNameResponse,
  GetBankListParams,
  GetBankListResponse,
} from '@nxsys/types/api/bank';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useGetBankList = () => {
  const { value, loading, error, run } = useAsync<
    GetBankListResponse,
    GetBankListParams
  >(getBankListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useAddBankName = () => {
  const { value, loading, error, run } = useAsync<
    AddBankNameResponse,
    AddBankNameParams
  >(addBankNameApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};
